import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
} from '@material-ui/core';
import styled from 'styled-components';
import { em } from 'polished';

const Container = styled(FormControl)`
  margin-top: ${em(16)};
  width: 100%;
`;

function Dropdown({
  children,
  disabled,
  error,
  errorMessage,
  onBlur,
  onChange,
  id,
  label,
  name,
  required,
  value,
}) {
  return (
    <Container disabled={disabled} error={error}>
      <InputLabel htmlFor={id}>
        {label} {required && '*'}
      </InputLabel>
      <Select
        inputProps={{
          id,
          name,
          onBlur,
        }}
        onChange={onChange}
        value={value}
      >
        {children}
      </Select>
      {error && <FormHelperText>{errorMessage}</FormHelperText>}
    </Container>
  );
}

Dropdown.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,

  children: PropTypes.any,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Dropdown.defaultProps = {
  disabled: false,
  error: false,
  required: false,
  value: '',
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/modules/common/Dropdown.js